module.exports = __webpack_public_path__ + "img/22.91e91f5b.png";